import toast from "react-hot-toast";
import axiosSetup from "../utils/axiosSetup";
import { Navigations, NavItem } from "../models/userData.model";

export const fetchAllUsers = async () => {
  try {
    const res = await axiosSetup.get("users/getUsers");
    return res.data.data;
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};

export const handleUpdateUser = async (
  userId: string,
  updatedData: {
    username?: string;
    email?: string;
    mobileNumber?: string;
    role?: string;
    manager?: string;
    states?: string[];
    districts?: string[];
    newPassword?: string;
    isGeoLocationEnabled?: boolean;
    trackLocation?: boolean;
  },
) => {
  try {
    const response = await axiosSetup.put(
      `users/updateUser/${userId}`,
      updatedData,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error updating user", error);
    toast.error("Error updating user");
    throw error;
  }
};

export const handleRegister = async (newUser: {
  username: string;
  email: string;
  password: string;
  mobileNumber: string;
  states: string[];
  districts: string[];
  role: string;
  manager?: string;
  geoLocation?: boolean;
  trackLocation?: boolean;
  warehouseAssigned?: string;
  navigations?: {
    main: [];
    extras: [];
    frelit: [];
    notifications: null;
    customerNotifications: null;
  };
}) => {
  const {
    username,
    email,
    password,
    mobileNumber,
    states,
    districts,
    role,
    manager,
    geoLocation,
    trackLocation,
    warehouseAssigned,
    navigations,
  } = newUser;

  if (!username || !email || !password || !role || !mobileNumber) {
    const message = "Please fill in all required fields";
    toast.error(message);
    throw new Error(message);
  }
  try {
    const manager1 = manager === "" ? null : manager;
    const response = await axiosSetup.post("/register", {
      username,
      email,
      password,
      role,
      mobileNumber,
      manager: manager1,
      states,
      districts,
      geoLocation,
      trackLocation,
      warehouseAssigned,
      navigations,
    });

    return response.data.data;
  } catch (err: any) {
    throw err;
  }
};

export const fetchUserNamesApi = async (search?: string) => {
  try {
    const res = await axiosSetup.get(
      `users/all-user-names${search ? `?search=${search}` : ""}`,
    );
    return res.data.data;
  } catch (err: any) {
    const msg = err.response?.data?.message;
    toast.error(msg);
    throw err;
  }
};
export const fetchSalesRepsApi = async (
  userId: string,
  params: { search?: string; page?: number; limit?: number } = {
    limit: 10,
    page: 1,
  },
) => {
  try {
    const res = await axiosSetup.get(`users/sales-reps/${userId}`, { params });
    return res.data;
  } catch (err: any) {
    const msg = err.response?.data?.message;
    toast.error(msg);
    throw err;
  }
};
export const fetchRoleNavigationByRole = async (role: string) => {
  try {
    const res = await axiosSetup.get(
      `users/getRoleNavigationByRole?role=${role}`,
    );
    return res.data.data;
  } catch (err: any) {
    const msg =
      err.response?.data?.message || "Failed to fetch role navigation";
    toast.error(msg);
    throw err;
  }
};

export const addNavigationApi = async (navigations: NavItem) => {
  try {
    const res = await axiosSetup.post("navigation/add-navigation", {
      navigations,
    });
    return res.data.data;
  } catch (err: any) {
    const msg = err.response?.data?.message || "Failed to add navigation";
    toast.error(msg);
    throw err;
  }
};

export const fetchAllNavigation = async () => {
  try {
    const res = await axiosSetup.get("/navigation/get-all-navigation");
    return res.data.data;
  } catch (err: any) {
    const msg = err.response?.data?.message || "Failed to fetch navigation";
    toast.error(msg);
    throw err;
  }
};

export const updateRoleNavigationApi = async (data: {
  role: string;
  navigations: Navigations;
}) => {
  try {
    const res = await axiosSetup.patch(
      "/navigation/update-role-navigation",
      data,
    );
    return res.data.data;
  } catch (err: any) {
    const msg =
      err.response?.data?.message || "Failed to update role navigation";
    toast.error(msg);
    throw err;
  }
};

export const disableUserApi = async (userId: string) => {
  try {
    const res = await axiosSetup.patch(`users/disable-user/${userId}`);
    return res.data.data;
  } catch (err: any) {
    const msg = err.response?.data?.message || "Failed to disable user";
    toast.error(msg);
    throw err;
  }
};

export const getDisabledUsersApi = async () => {
  try {
    const res = await axiosSetup.get("users/disabled-users");
    return res.data.data;
  } catch (err: any) {
    const msg = err.response?.data?.message || "Failed to fetch disabled users";
    toast.error(msg);
    throw err;
  }
};
